import { activityEpic } from './actions/activity';
import { alertsEpic } from './actions/alerts';
import { archiveEpic } from './actions/archive';
import { birthdaysEpic } from './actions/birthdays';
import { contactsEpic } from './actions/contacts';
import { groupsEpic } from './actions/groups';
import { highlightsEpic } from './actions/highlights';
import { locationsEpic } from './actions/locations';
import { momentsEpic } from './actions/moments';
import { nexusEpic } from './actions/nexus';
import { notesEpic } from './actions/notes';
import { reconnectEpic } from './actions/reconnect';
import { searchEpic } from './actions/search';
import { sharedDataEpics } from './actions/shared';
import { shareStatusesEpics } from './actions/shareStatuses';
import { sourcesEpic } from './actions/sources';
import { starredEpic } from './actions/starred';
import { timelineEpic } from './actions/timeline';
import { uiEpic } from './actions/ui';
import { userSettingsEpic } from './actions/userSettings';
import { userEpic } from './actions/user';
import { publicProfileEpic } from './actions/publicProfile';
import { integrationsEpic } from './actions/integrations';
import { groupActivityEpic } from './actions/groupActivity';
import { csvImportEpics } from './actions/csvImport';
import { duplicatesEpic } from './actions/duplicates';

export default {
  activityEpic,
  alertsEpic,
  archiveEpic,
  birthdaysEpic,
  contactsEpic,
  csvImportEpics,
  duplicatesEpic,
  groupsEpic,
  groupActivityEpic,
  highlightsEpic,
  integrationsEpic,
  locationsEpic,
  momentsEpic,
  nexusEpic,
  notesEpic,
  publicProfileEpic,
  reconnectEpic,
  sharedDataEpics,
  shareStatusesEpics,
  searchEpic,
  sourcesEpic,
  starredEpic,
  timelineEpic,
  uiEpic,
  userSettingsEpic,
  userEpic,
};
